<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <cook-logo v-if="!empresaExiste"></cook-logo>
    <div v-else>
      <nav-bar-only></nav-bar-only>
      <logo-empresa></logo-empresa>
      <div class="conteudo cor-secundaria-bg">
        <h1 class="splash-texto-1 splash-cor-1" v-html="this.$store.state.empresa.splash_texto_1"
            style="width: 100%"></h1>
        <p class="splash-texto-2 splash-cor-2" style="width: 100%"
           v-html="this.$store.state.empresa.splash_texto_2.length > 200  ? this.$store.state.empresa.splash_texto_2.slice(0,200) + '...' : this.$store.state.empresa.splash_texto_2"></p>
        <button
          class="btn waves-effect splash-texto-botao cor-primaria-text" @click="Menu()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto;
    margin-right: auto; font-weight: bold">
              {{ this.$store.state.empresa.aberto == 'S' ? this.$store.state.empresa.splash_texto_botao : "VEJA O CARDÁPIO" }}
            </div>
          </div>
        </button>
      </div>
      <div class="caixa-flutuante-inferior materialize-green center-block"
           v-if="this.$store.state.empresa.aberto == 'S'">
        <div class=" " style="padding: 0;margin-top: 7px">
          <img src="@/assets/papagaio.png" style="height: 30px"/>
          <div class="texto-status">LOJA ONLINE</div>
        </div>
      </div>
      <caixa-flutuante-inferior
        v-else
        altura="40"
        class="materialize-red"
      >
        <div class="center-block">
          <div class="material-icons md-18 margin-status">fiber_manual_record</div>
          <div class="texto-status">LOJA OFFLINE</div>
        </div>
      </caixa-flutuante-inferior>
    </div>
  </div>
</template>

<script>
import CaixaFlutuanteInferior from "../Widgets/CaixaFlutuanteInferior";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

import NavBar from "../Widgets/NavBar";
import CookLogo from "../Widgets/CookLogo";
import LogoEmpresa from "../Widgets/LogoEmpresa";
import NavBarOnly from "../Widgets/NavBarOnly";

import Swal from 'sweetalert2'

export default {
  name: "Inicio",
  components: {
    NavBarOnly,
    LogoEmpresa,
    CookLogo,
    NavBar,
    CaixaFlutuanteInferior,
    Loading
  },
  data() {
    return {
      empresaExiste: false,
      isLoading: false,
      fullPage: true
    };
  },
  mounted() {
    this.VerificarEmpresa();
    this.getLocation();
    this.checarCupom();
  },
  methods: {
    checarCupom(){
      let cupom = '';
      try {
        if (this.$route.query.cupom) {
          this.isLoading = true;
          this.validarCupom();
        }
      }catch (e) {

      }
    },
    async validarCupom(){
      let localizacao  = localStorage.getItem('localizacao');
      await axios
        .get(this.$store.state.apiUrl + "cupom-desconto/validar?empresa=" + this.$store.state.empresa_url + "&subtotal="+ this.$store.getters.pedidoSubtotal.toFixed(2) +"&codigo_ativacao="+ this.$route.query.cupom +"&localizacao=" + localizacao)
        .then(res => {
          this.isLoading = false;
          if (res.data) {

            this.$store.state.cupom_desconto = this.$route.query.cupom;
            Swal.fire({
              title: 'Woohoo! 🤑',
              text: res.data,
              imageUrl: 'https://res.cloudinary.com/sirrus/image/upload/v1626188032/delivery/67577-reward-recieved_l7tias.gif',
              imageHeight: 150,
              backdrop: `
              rgba(65 105 225 / 85%)
              left top
              no-repeat`
            });

          }
        })
        .catch(error => {
          this.isLoading = false;
          Swal.fire({
            title: 'Ops...',
            text:error.response.data
          })

        });
    },
    getLocation() {
      try{
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition);
        } else {
          alert("A geolocalização não é compatível com este navegador.");
        }
      }catch (e){}
    },
    showPosition(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      localStorage.setItem('localizacao',lat + ','+lng);
    },
    async VerificarEmpresa() {
      this.isLoading = true;
      this.$store.commit("empresaUrl", this.$router.currentRoute.params.empresa);
      await axios
        .get(this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url)
        .then(res => {
          if (res.data) {
            this.$store.commit("empresa", res.data);
            this.empresaExiste = true;
            this.isLoading = false;
          }
        })
        .catch(error => this.isLoading = false);

      if (!this.empresaExiste)
        this.$router.push("/404/nao-localizado");
    },
    Menu() {
      this.$router.push("/" + this.$store.state.empresa_url + "/menu");
    }
  }
};
</script>

<style scoped>

.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: center;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  padding: 0.2rem 0rem;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  margin: 0px auto;
  z-index: 999;
  color: white;
}

html {
  -webkit-text-size-adjust: none
}

.eVcNXl {
  position: relative;
  padding-top: 48px;
  width: 100%;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
  background: rgb(255, 255, 255);
}

.conteudo {
  position: absolute;
  top: 200px;
  bottom: 40px;
  left: 0;
  right: 0;
  padding: 0 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  -webkit-box-align: center;
  align-items: center;
  color: #fff;
}

.conteudo .splash-texto-1 {
  font-size: 24px;
  font-weight: bold;
}

.conteudo .splash-texto-2 {
  font-size: 21px;
}

.conteudo .splash-texto-botao {
  width: 94%;
  height: 50px;
  margin: 0;
  padding: 6px 0 0 0;
  background-color: #fff;
  border-radius: 8px;
  white-space: nowrap;
  font-size: 16px;
  max-width: 540px
}

.conteudo .splash-texto-botao div span {
  padding: 0;
}

.margin-status {
  margin-top: 4px;
}

.texto-status {
  float: right;
  margin-left: 6px;
  font-size: 18px;
}

@media screen and (max-height: 640px) {
  .conteudo {
    /*top: 180px;*/
    top: 195px;
  }
}

@media screen and (max-height: 540px) {
  .conteudo {
    /*top: 160px;*/
    top: 160px;
  }
}

@media screen and (max-height: 479px) {
  .splash-texto-botao {
    position: absolute;
    bottom: 10px;
  }
}

@media screen and (max-width: 360px) {
  .conteudo {
    padding: 0 1em;
  }

  .conteudo .splash-texto-1 {
    font-size: 23px;
    font-weight: bold;
  }

  .conteudo .splash-texto-2 {
    font-size: 21px;
  }

  .conteudo .splash-texto-botao {
    font-size: 15px;
  }

  .conteudo .splash-texto-botao div span {
    font-size: 34px;
    margin-top: 2px;
  }
}

@media screen and (max-width: 320px) {
  .conteudo .splash-texto-1 {
    font-size: 21px;
    font-weight: bold;
  }

  .conteudo .splash-texto-2 {
    font-size: 19px;
  }

  .conteudo .splash-texto-botao {
    font-size: 14px;
  }

  .conteudo .splash-texto-botao div span {
    font-size: 28px;
    margin-top: 5px;
  }
}
</style>

<style>
.conteudo .splash-texto-1, .conteudo .splash-texto-1 > p,
.conteudo .splash-texto-2, .conteudo .splash-texto-2 > p {
  margin: 5px 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Inicio.vue